import { Icon, Tooltip } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';

export interface MinimumApplicationTooltipProps {
  minimumApplicationNormalized: string;
  monthlyMinimumApplicationNormalized: string;
}

export const MinimumApplicationTooltip: React.FC<MinimumApplicationTooltipProps> = ({
  minimumApplicationNormalized,
  monthlyMinimumApplicationNormalized,
}) => {
  return (
    <Tooltip
      width="320px"
      label={`Realizando um aporte inicial igual ou maior que ${minimumApplicationNormalized}, a contribuição mensal mínima poderá ser menor que ${monthlyMinimumApplicationNormalized}.`}>
      <Box>
        <Icon name="Info" size="xxs" />
      </Box>
    </Tooltip>
  );
};
